module.exports = __webpack_public_path__ + "img/cancel3.65bd0413.jpg";